import React from "react";
import mission from "../img/misyon vizyon foto.jpg";
import LanguageApi from "../components/Language";
const Mission = () => {
  const {mission_title, mission_text} = LanguageApi();
  return (
    <div className="corporate">
      <div className="corporate-img">
        <img src={mission} alt="corporate" />
      </div>
      <div className="corporate-head">
        <div className="corporate-head-in">
          <h1>{mission_title}</h1>
        </div>
      </div>
      <div className="corporate-body">
        <div className="corporate-body-in" dangerouslySetInnerHTML={{__html: mission_text}}>
        </div>
      </div>
    </div>
  );
};

export default Mission;
